<div>
    <div class="textpages__content textpages__contact">
        <div class="textpages__content-col2">
            <form class="form" @submit.prevent="activeValidation = true; onSubmit();">
                <div class="form__group">
                    <input type="text" name="name" :placeholder="$t('textpages.contact.name-placeholder')" v-model="name">
                    <div class="form__group-alert" v-if="errors.name && activeValidation" v-t="'textpages.alerts.errorinvalidName'"></div>
                </div>
                <div class="form__group">
                    <input type="text" name="email" :placeholder="$t('textpages.contact.email-placeholder')" v-model="email">
                    <div class="form__group-alert" v-if="errors.email && activeValidation" v-t="'textpages.alerts.errorinvalidEmail'"></div>
                </div>
                <div class="form__group">
                    <input type="text" :placeholder="$t('textpages.contact.subject-placeholder')" v-model="subject">
                    <div class="form__group-alert" v-if="errors.subject && activeValidation" v-t="'textpages.alerts.errorinvalidSubject'"></div>
                </div>
                <div class="form__group">
                    <textarea name="message" v-model="message" :placeholder="$t('textpages.contact.message-placeholder')"></textarea>
                    <div class="form__group-alert" v-if="errors.message && activeValidation" v-t="'textpages.alerts.errorinvalidMessage'"></div>
                </div>
                <div class="form__group">
                    <button type="submit" class="btn" v-t="'account.inbox.send'"></button>
                </div>
            </form>
        </div>
        <div class="textpages__content-col2"><span v-html="pageData"></span></div>
    </div>
    <hr />
    <div class="textpages__content textpages__contact">
        <div class="textpages__content-col0 textpages__contact-faq">
            <h2>{{ $t('textpages.contact.faq') }}</h2>
            <ul v-if="faqData">
                <li v-for="(question, index) in getItems(faqData)" :class="{active: activeQuestion === index}" v-on:click="activeQuestion = index">
                    <h2>{{ question.name }}</h2>
                    <p v-html="question.description"></p>
                </li>
            </ul>
        </div>
    </div>
</div>
